import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

import * as currentUserStoreModule from '@/store/global/currentUser';
const { registerReducer, registerMiddleware } = useStorymapStore();

export class AddOrRemoveActivityToTrackingFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'AddOrRemoveActivityToTrackingFilter';

    public constructor(public activityId: string) {
        super(AddOrRemoveActivityToTrackingFilter.ACTION_TYPE);
    }
}

//eslint-disable-next-line
const dismissMiddleware = async (state: StorymapState, action: AddOrRemoveActivityToTrackingFilter): Promise<boolean> => {
    const store = currentUserStoreModule.useCurrentUserModule();

    await store.dispatch(new currentUserStoreModule.DismissQuickTip('RELEASE_VIEW_FILTER_DISMISS_KEY'));
    return true;
};

const reducer = (state: StorymapState, action: AddOrRemoveActivityToTrackingFilter): void => {
    const activityId = state.trackingViewState.filterActivityIds.find((x) => x === action.activityId);

    const taskIds = state.tasks.filter(x => x.activityId == action.activityId).map(x => x.id);

    if (activityId == null) {
        state.trackingViewState.filterActivityIds.push(action.activityId);

        if (taskIds) {
            state.trackingViewState.filterTaskIds = [...state.trackingViewState.filterTaskIds, ...taskIds];
        }
    } else {
        state.trackingViewState.filterActivityIds = state.trackingViewState.filterActivityIds.filter((x) => x !== action.activityId);

        if (taskIds) {
            state.trackingViewState.filterTaskIds = state.trackingViewState.filterTaskIds.filter((id) => !taskIds.includes(id));
        }
    }
};

//@ts-ignore
registerMiddleware(AddOrRemoveActivityToTrackingFilter.ACTION_TYPE, dismissMiddleware);

//@ts-ignore
registerReducer(AddOrRemoveActivityToTrackingFilter.ACTION_TYPE, reducer);